import { Form, ButtonGroup, Button, Row, Col, Card } from 'react-bootstrap';
//import { Calendar, List, Grid3x3, Clock } from 'lucide-react';
//import { Professional, ServiceFunction, ViewMode } from './types/appointment.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';



export const FilterBar = ({
  listProfissionais,
  functions,
  selectedProfessional,
  selectedFunction,
  selectedStatus,
  viewMode,
  handleChangeFiltro,
  onViewModeChange,
}) => {


  const statusOptions = [
    { value: 'all', label: 'Todos os Status' },
    { value: 'confirmed', label: 'Confirmado' },
    { value: 'pending', label: 'Pendente' },
    { value: 'cancelled', label: 'Cancelado' },
  ];

  const viewModes = [
    { mode: 'month', icon: <FontAwesomeIcon icon={faCalendar} />, label: 'Mês' },
    { mode: 'week', icon: '-', label: 'Semana' },
    { mode: 'day', icon: '-', label: 'Dia' },
    { mode: 'list', icon: '-', label: 'Lista' },
  ];


  return (
    <Card className="shadow-sm animate-fade-in">
      <Card.Body>
        <Row className="g-3 align-items-center">
          <Col xs={12} lg={8}>
            <Row className="g-2">
              <Col xs={12} sm={4}>
                <Form.Select
                  name="filtro_tp_servico"
                  value={selectedFunction}
                  onChange={(e) =>handleChangeFiltro(e)}
                  size="sm"
                >
                  <option value="all">Todas as Funções</option>
                  {functions.map((fn) => (
                    <option key={fn.id} value={fn.id}>
                      {fn.nome}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={12} sm={4}>
                <Form.Select
                  value={selectedProfessional}
                  onChange={(e) => handleChangeFiltro(e)}
                  size="sm"
                >
                  <option value="all">Todos os Profissionais</option>
                  {listProfissionais?.map((prof) => (
                    <option key={prof?.id} value={prof?.id}>
                      {prof?.nome}
                    </option>
                  ))}
                </Form.Select>
              </Col>

              <Col xs={12} sm={4}>
                <Form.Select
                  value={selectedStatus}
                  onChange={(e) => handleChangeFiltro(e)}
                  size="sm"
                >
                  {statusOptions.map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          </Col>

          <Col xs={12} lg={4}>
            <ButtonGroup className="w-100">
              {viewModes.map(({ mode, icon, label }) => (
                <Button
                  key={mode}
                  variant={viewMode === mode ? 'primary' : 'outline-primary'}
                  size="sm"
                  onClick={() => onViewModeChange(mode)}
                  className="d-flex align-items-center justify-content-center gap-1"
                >
                  {icon}
                  <span className="d-none d-sm-inline">{label}</span>
                </Button>
              ))}
            </ButtonGroup>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
